import api from 'services/technical-visit/technician'
import { AutocompleteResult } from 'utils/types'

export const responsibleTechnicianAutocomplete = async (text: string): Promise<Array<AutocompleteResult>> => {
  if (!text) return []

  let res = await api.autocomplete({ text })

  if (!res?.data?.success) return []

  return res?.data?.data
}
